import Gumshoe from 'gumshoejs'
import axios from 'axios'
import swal from 'sweetalert'
import Swiper from 'swiper'
import Pikaday from 'pikaday'

const headerDom = document.querySelector('header')
const footerDom = document.querySelector('footer')
const contentDom = document.querySelector('.main')
const checkboxDummy = document.querySelectorAll('.checkbox-dummy')
const otherText = document.getElementById('otherText')
const outerPageForm = document.querySelector('.outer-page-form')
const formPopupClose = document.querySelector('.form-popup-close')
const htmlDom = document.querySelector('html')
const dt = document.getElementById('dt')
const demo = document.getElementById('demo')
const choose = document.getElementById('choose')
const formDemoSchedule = document.getElementById('formDemoSchedule')
const appForm = document.querySelectorAll('.appForm')
const idcCheck = document.getElementById('idc')
const gartnerCheck = document.getElementById('gartner')

function headerScroll() {
  const wScroll = window.scrollY
  if (wScroll > 40) {
    headerDom.classList.add('header--scroll')
  } else {
    headerDom.classList.remove('header--scroll')
  }
}

headerScroll()

window.addEventListener('scroll', headerScroll)

window.onload = () => {
  contentDom.style.marginTop = `${headerDom.offsetHeight}px`
  contentDom.style.marginBottom = `${footerDom.offsetHeight}px`

  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    initialSlide: 0,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      960: {
        autoHeight: false
      },
      768: {
        autoHeight: false
      },
      540: {
        autoHeight: true
      },
      320: {
        autoHeight: true
      }
    }
  })
}

const serialize = (formEl) => {
  const formData = [];
  for (let i = 0; i < formEl.elements.length; i++) {
    const field = formEl.elements[i];
    if (field.name && !field.disabled && field.type !== 'button' && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit') {
      if (field.type === 'checkbox' && !field.checked) {
        continue
      }
      formData[formData.length] = `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`;
    }
  }
  return formData.join('&').replace(/%20/g, '+');
};

function setInputFilter(textbox, inputFilter) {
  ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
    textbox.addEventListener(event, function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      /*  eslint no-prototype-builtins: ["off"] */
      } else if (this.hasOwnProperty('oldValue')) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  });
}

document.querySelectorAll('.input__number-only').forEach((input) => {
  setInputFilter(input, function (value) {
    return /^\d*\.?\d*$/.test(value);
  });
});

checkboxDummy.forEach((check) => {
  check.addEventListener('change', (e) => {
    const checkValue = e.target.value
    if (checkValue === 'Other') {
      if (e.target.checked) {
        otherText.classList.remove('form-input-hidden')
      } else {
        otherText.classList.add('form-input-hidden')
        otherText.value = ''
      }
    } else if (checkValue === 'Personalized Demo') {
      if (e.target.checked) {
        htmlDom.classList.add('no-scroll')
        outerPageForm.classList.add('outer-page-form--show')
      } else {
        dt.value = ''
        formDemoSchedule.value = ''
        htmlDom.classList.remove('no-scroll')
        outerPageForm.classList.remove('outer-page-form--show')
      }
    }
  })
})

const picker = new Pikaday({
  field: document.getElementById('dt'),
  format: 'DD/MM/YYYY',
  minDate: new Date(),
  firstDay: 1
})

formPopupClose.addEventListener('click', () => {
  demo.checked = false
  outerPageForm.classList.remove('outer-page-form--show')
  htmlDom.classList.remove('no-scroll')
})

choose.addEventListener('click', () => {
  if (dt.value === '') return false
  else {
    formDemoSchedule.value = dt.value
    outerPageForm.classList.remove('outer-page-form--show')
    htmlDom.classList.remove('no-scroll')
  }
})

function download(url, name) {
  const shadowLinkTag = document.createElement('a');
  shadowLinkTag.href = url;
  shadowLinkTag.download = name;
  shadowLinkTag.click();
}

appForm.forEach((form) => {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const data = serialize(this);
    const btnSubmit = this.querySelector('[type="submit"]');
    const btnText = btnSubmit.textContent;
    btnSubmit.setAttribute('disabled', 'true');
    btnSubmit.textContent = 'Submitting...';
    axios.post('https://predictable-hci.com/form-cloud.php', data)
      .then((res) => {
        if (res.data.success) {
          if (idcCheck.checked && gartnerCheck.checked) {
            swal('Terima kasih', 'Mengunduh... Data Sheet', 'success')
            setTimeout(() => {
              download('https://predictable-hci.com/assets/cloud/Cloud-Storage.zip', 'Cloud-Storage.zip')
            }, 3000)
          } else if (idcCheck.checked) {
            swal('Terima kasih', 'Mengunduh... IDC Perspective', 'success')
            setTimeout(() => {
              download('https://predictable-hci.com/assets/cloud/IDC_Perspective_A_New_NetApp_On_The_Rise.pdf', 'IDC_Perspective_A_New_NetApp_On_The_Rise.pdf')
            }, 3000)
          } else if (gartnerCheck.checked) {
            swal('Terima kasih', 'Mengunduh... Dell vs. NetApp: Dont Let Cloud be An Afterthought', 'success')
            setTimeout(() => {
              download('https://www.netapp.com/pdf.html?item=/media/19839-IMM_NetApp_Ebook_Competitive_Attack_v2_10192020.pdf', 'Dell_vs._NetApp:_Dont_Let_Cloud_be_An_Afterthought.pdf')
            }, 3000)
          } else {
            swal('Terima kasih', 'Data sukses terkirim', 'success');
          }
        } else {
          swal('Opps', res.data.message, 'error');
        }
      })
      .catch((err) => {
        swal('Opps', 'We are under maintenance', 'error');
        console.log(err);
      })
      .finally(() => {
        this.reset();
        grecaptcha.reset();
        btnSubmit.removeAttribute('disabled');
        btnSubmit.textContent = btnText;
        formDemoSchedule.value = ''
        otherText.classList.add('form-input-hidden')
      });
  })
})

const spy = new Gumshoe('#mainNav a', {
  reflow: true,
  offset() {
    return headerDom.getBoundingClientRect().height
  }
})

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    })
  })
})